import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Select } from 'primeng/select';
import { Toast } from 'primeng/toast';
import { Tooltip } from 'primeng/tooltip';
import Studio from '../../../../../types/studio/Studio';
import { RetailerService } from '../../../services/retailer.service';
import { VehicleModelSelectionCacheService } from '../../../services/vehicle-model-selection-cache.service';

@Component({
    selector: 'app-retailer-top-bar',
    imports: [
        FormsModule,
        Tooltip,
        Toast,
        Select
    ],
    templateUrl: './retailer-top-bar.component.html',
    styleUrl: './retailer-top-bar.component.scss'
})
export class RetailerTopBarComponent {

    @Input() public showBackArrow: boolean = false;
    @Input() public previousPage: string = '';
    @Input() public showNotificationBell: boolean = false;
    @Input() unreadNotificationCount: number = 1

    @Output() public onNotificationBell: EventEmitter<void> = new EventEmitter<void>();
    @Output() public onBack: EventEmitter<void> = new EventEmitter<void>;
    @Output() public onNewStudio: EventEmitter<void> = new EventEmitter<void>();

    public studios: Studio[] = [];
    public selectedStudioId: number | undefined = undefined;

    constructor(private router: Router, private retailerService: RetailerService,
                private messageService: MessageService, private cacheService: VehicleModelSelectionCacheService) {
        this.fetchStudios();
    }

    /**
     * Navigates back to the previous page.
     */
    public async onBackArrowClick(): Promise<void> {
        // Navigate back to a specific route or use a dynamic path
        this.onBack.emit();
        await this.router.navigate([ this.previousPage ]);

    }

    /**
     * Handles the click event on the notification bell icon.
     * Emits an event to notify the parent component.
     */
    public onNotificationBellClick(): void {
        this.onNotificationBell.emit();
    }

    /**
     * Fetches the list of studios from the retailer service, for the current user.
     */
    public fetchStudios(): void {
        this.retailerService.getStudios().then((studios) => {
            this.studios = studios;
            // Retrieve saved studio id from local storage
            const storedStudioId = localStorage.getItem('selectedStudioId');
            if (storedStudioId) {
                const parsedId = Number(storedStudioId);
                if (studios.find(s => s.id === parsedId)) {
                    this.selectedStudioId = parsedId;
                } else if (studios.length > 0) {
                    // Default to first studio if stored id isn't found
                    this.selectedStudioId = studios[0].id;
                }
            } else if (studios.length > 0) {
                // Default to the first studio if no id is stored
                this.selectedStudioId = studios[0].id;
            }
            this.onStudioChange();
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000
            });
        });
    }

    /**
     * Handles the change in selected studio.
     * Updates the local storage with the new selected studio id.
     */
    public onStudioChange(): void {
        // Update local storage with the new selected studio id.
        let storedStudioId = localStorage.getItem('selectedStudioId');
        if (this.selectedStudioId && this.selectedStudioId.toString() !== storedStudioId) {
            localStorage.setItem('selectedStudioId', this.selectedStudioId.toString());
            this.cacheService.clear();
            this.onNewStudio.emit();
        }
    }
}
